<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Haftkraft Vorderseite</th>
          <th scope="col" class="multi-line-header">Benetzung Vorderseite</th>
          <th scope="col" class="multi-line-header">Haftkraft Rückseite</th>
          <th scope="col" class="multi-line-header">Benetzung Rückseite</th>
          <th scope="col" class="multi-line-header">
            Siliziumausbrüche Vorderseite
          </th>
          <th scope="col" class="multi-line-header">
            Siliziumausbrüche Rückseite
          </th>
          <th scope="col" class="multi-line-header">Gesamtergebnis i.O.</th>
          <th scope="col" class="multi-line-header">
            Produktionslinie Stringer
          </th>
          <th scope="col" class="multi-line-header">Bemerkungen</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateInProduction.replace("T", " ") }}</td>

          <td>{{ entry.username }}</td>

          <td :class="{ criteria: entry.adhesiveForceFrontMin < 0.84 }">
            {{ entry.adhesiveForceFrontMin }}-{{ entry.adhesiveForceFrontMax }}N
          </td>

          <td :class="{ criteria: entry.lubricationFront < 75 }">
            {{ entry.lubricationFront }}%
          </td>

          <td :class="{ criteria: entry.adhesiveForceBackMin < 2 }">
            {{ entry.adhesiveForceBackMin }}-{{ entry.adhesiveForceBackMax }}N
          </td>

          <td :class="{ criteria: entry.lubricationBack < 75 }">
            {{ entry.lubricationBack }}%
          </td>

          <td v-if="entry.isSiliciumBreakoutsFront">Ja</td>
          <td v-else>Nein</td>

          <td v-if="entry.isSiliciumBreakoutsBack">Ja</td>
          <td v-else>Nein</td>

          <td v-if="entry.isGood">Ja</td>
          <td v-else>Nein</td>

          <td>{{ entry.manufacturingLine }}</td>

          <td>{{ entry.notes }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;
  } catch (error) {
    if (error.response) {
      console.log("HTTP Fehler:", error.response.status);
    } else {
      console.log("Netzwerkproblem:", error.message);
    }
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.criteria {
  color: darkorange !important;
}
</style>
